import { render, staticRenderFns } from "./WBtn.vue?vue&type=template&id=1e6ad1d4&scoped=true&"
import script from "./WBtn.vue?vue&type=script&lang=js&"
export * from "./WBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6ad1d4",
  null
  
)

export default component.exports